var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2" },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c(
                "v-alert",
                {
                  attrs: { type: "error", title: "System Error" },
                  model: {
                    value: _vm.errorMessage,
                    callback: function($$v) {
                      _vm.errorMessage = $$v
                    },
                    expression: "errorMessage"
                  }
                },
                [
                  _c("strong", [_vm._v("error URL: ")]),
                  _vm._v(" " + _vm._s(this.errorURL) + "\n        "),
                  _c("p", [
                    _vm._v(
                      "\n          " + _vm._s(this.errorText) + "\n        "
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c(
                "v-toolbar",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", dark: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.dialog = true
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("mdi-plus")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text" }, [
                        _vm._v("Add\n            Jump")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.newWalkIn()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("mdi-basket-plus")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text" }, [
                        _vm._v("Merch Sale")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: _vm.groupPayJumpers.length < 1,
                        loading: _vm.loading,
                        color: "green"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.groupDialog = true
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("mdi-playlist-check")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text" }, [
                        _vm._v("Pay\n            Together")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-dialog",
                    {
                      attrs: { "max-width": "600px" },
                      on: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "esc", 27, $event.key, [
                              "Esc",
                              "Escape"
                            ])
                          ) {
                            return null
                          }
                          _vm.groupDialog = false
                        }
                      },
                      model: {
                        value: _vm.groupDialog,
                        callback: function($$v) {
                          _vm.groupDialog = $$v
                        },
                        expression: "groupDialog"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c("v-card-title", [
                            _vm._v(
                              "\n              Group Payment\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-form",
                            {
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.payTogether($event)
                                }
                              },
                              model: {
                                value: _vm.valid,
                                callback: function($$v) {
                                  _vm.valid = $$v
                                },
                                expression: "valid"
                              }
                            },
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-data-table",
                                    {
                                      staticClass: "no-footer-table",
                                      attrs: {
                                        headers: _vm.groupHeaders,
                                        items: _vm.allGroupItems,
                                        "item-key": "id"
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "item.price",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  "$" + _vm._s(item.price) + " "
                                                )
                                              ])
                                            ]
                                          }
                                        }
                                      ])
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("template", { slot: "body.append" }, [
                                        _c(
                                          "tr",
                                          { staticClass: "pink--text" },
                                          [
                                            _c("th", { staticClass: "title" }, [
                                              _vm._v("Total")
                                            ]),
                                            _vm._v(" "),
                                            _c("th", { staticClass: "title" }, [
                                              _vm._v(
                                                "$" +
                                                  _vm._s(
                                                    _vm.sum(
                                                      _vm.allGroupItems,
                                                      "price"
                                                    )
                                                  )
                                              )
                                            ])
                                          ]
                                        )
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card-actions",
                                [
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.groupDialog = false
                                        }
                                      }
                                    },
                                    [_vm._v("Close")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        loading: _vm.groupLoading,
                                        color: "green",
                                        type: "Submit"
                                      }
                                    },
                                    [
                                      _c("v-icon", { attrs: { left: "" } }, [
                                        _vm._v("mdi-playlist-check")
                                      ]),
                                      _vm._v("Paid ")
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "6" } },
            [
              _c(
                "v-card",
                { staticClass: "pa-2", attrs: { tile: "" } },
                [
                  _c(
                    "v-dialog",
                    {
                      model: {
                        value: _vm.dialog,
                        callback: function($$v) {
                          _vm.dialog = $$v
                        },
                        expression: "dialog"
                      }
                    },
                    [
                      _c(
                        "v-stepper",
                        {
                          attrs: { vertical: "" },
                          model: {
                            value: _vm.step,
                            callback: function($$v) {
                              _vm.step = $$v
                            },
                            expression: "step"
                          }
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "8" } },
                                [
                                  _c(
                                    "v-form",
                                    {
                                      ref: "customerDataForm",
                                      on: {
                                        submit: function($event) {
                                          $event.preventDefault()
                                          return _vm.save($event)
                                        }
                                      },
                                      model: {
                                        value: _vm.valid,
                                        callback: function($$v) {
                                          _vm.valid = $$v
                                        },
                                        expression: "valid"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-stepper-step",
                                        {
                                          attrs: {
                                            complete: _vm.saved,
                                            step: "1"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.formTitle) +
                                              "\n                    " +
                                              _vm._s(_vm.editedItem.code) +
                                              " - " +
                                              _vm._s(_vm.editedItem.fullName) +
                                              "\n\n                    "
                                          ),
                                          _vm.editedItem.bookingNumber
                                            ? _c("small", [
                                                _c("strong", [
                                                  _vm._v("Booking No.:")
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.editedItem
                                                        .bookingNumber
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-stepper-content",
                                        { attrs: { step: "1" } },
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "12", md: "6" }
                                                },
                                                [
                                                  _c(
                                                    "fieldset",
                                                    {
                                                      staticClass: "inline-form"
                                                    },
                                                    [
                                                      _c("v-select", {
                                                        attrs: {
                                                          items: _vm.products,
                                                          rules: _vm.codeRules,
                                                          "item-text": "code",
                                                          "item-value": "code",
                                                          value:
                                                            _vm.editedItem.code,
                                                          label: "Package"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem.code,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "code",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.code"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      !_vm.editedItem
                                                        .bookingNumber
                                                        ? _c("v-text-field", {
                                                            staticClass:
                                                              "date-time-field",
                                                            attrs: {
                                                              min:
                                                                _vm.currentDate,
                                                              type:
                                                                "datetime-local",
                                                              label:
                                                                "Date and Time",
                                                              rules:
                                                                _vm.startTimeRules
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.editedItem
                                                                  .startTime,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.editedItem,
                                                                  "startTime",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "editedItem.startTime"
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "12", md: "6" }
                                                },
                                                [
                                                  _c(
                                                    "fieldset",
                                                    {
                                                      staticClass: "inline-form"
                                                    },
                                                    [
                                                      _c("v-select", {
                                                        ref: "agent",
                                                        attrs: {
                                                          items:
                                                            _vm.allAgentsNames,
                                                          label: "Agent",
                                                          "item-text": "name",
                                                          "item-value": "name",
                                                          value:
                                                            _vm.editedItem
                                                              .creationAgent,
                                                          "persistent-hint": "",
                                                          "hide-details": ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .creationAgent,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "creationAgent",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.creationAgent"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-select", {
                                                        attrs: {
                                                          items: [
                                                            "Bus",
                                                            "Airplane",
                                                            "Self Drive"
                                                          ],
                                                          required: "",
                                                          label: "Transport"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .transport,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "transport",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.transport"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "12", md: "6" }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label: "Full Name",
                                                      rules: _vm.req
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.editedItem.fullName,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.editedItem,
                                                          "fullName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "editedItem.fullName"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label:
                                                        "Photo Identification #",
                                                      required: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.editedItem.IDnumber,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.editedItem,
                                                          "IDnumber",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "editedItem.IDnumber"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "fieldset",
                                                    {
                                                      staticClass: "inline-form"
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          type: "date",
                                                          label: "DOB",
                                                          required: "",
                                                          max: _vm.min_dob
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .dateOfBirth,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "dateOfBirth",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.dateOfBirth"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-radio-group",
                                                        {
                                                          model: {
                                                            value:
                                                              _vm.editedItem
                                                                .gender,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.editedItem,
                                                                "gender",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "editedItem.gender"
                                                          }
                                                        },
                                                        [
                                                          _c("v-radio", {
                                                            attrs: {
                                                              label: "Male",
                                                              value: "Male"
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("v-radio", {
                                                            attrs: {
                                                              "float-right": "",
                                                              label: "Female",
                                                              value: "Female"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "fieldset",
                                                    {
                                                      staticClass: "inline-form"
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          type: "number",
                                                          label: "Weight",
                                                          rules: _vm.weightRules
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .weight,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "weight",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.weight"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          type: "number",
                                                          label: "Height"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .height,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "height",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.height"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "12", md: "6" }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label: "Address",
                                                      required: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.editedItem.address1,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.editedItem,
                                                          "address1",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "editedItem.address1"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "fieldset",
                                                    {
                                                      staticClass: "inline-form"
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: "City",
                                                          required: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem.city,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "city",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.city"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: "State",
                                                          required: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .state,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "state",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.state"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "fieldset",
                                                    {
                                                      staticClass: "inline-form"
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: "Zip Code",
                                                          required: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .postcode,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "postcode",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.postcode"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: "Country",
                                                          rules:
                                                            _vm.countryCodeRules
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .countryCode,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "countryCode",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.countryCode"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "fieldset",
                                                    {
                                                      staticClass: "inline-form"
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: "Phone Number"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .phoneNumber,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "phoneNumber",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.phoneNumber"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          rules: _vm.emailRules,
                                                          label: "E-mail"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .emailAddress,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "emailAddress",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.emailAddress"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "12", md: "6" }
                                                },
                                                [
                                                  _c(
                                                    "v-radio-group",
                                                    {
                                                      model: {
                                                        value: _vm.pdf,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.pdf = $$v
                                                        },
                                                        expression: "pdf"
                                                      }
                                                    },
                                                    [
                                                      _c("v-radio", {
                                                        attrs: {
                                                          label:
                                                            "Multiple Pages",
                                                          value: "multi"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-radio", {
                                                        attrs: {
                                                          "float-right": "",
                                                          label: "1 Page",
                                                          value: "single"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-col", {
                                                attrs: { cols: "12", md: "6" }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card-actions",
                                            [
                                              _vm.formTitle !== "New Jump" ||
                                              _vm.saved
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        href: _vm.waiver,
                                                        color: "green darken-3"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Get\n                        Waiver"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("v-spacer"),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  class: { hidden: _vm.saved },
                                                  attrs: { text: "" },
                                                  on: { click: _vm.close }
                                                },
                                                [_vm._v("Cancel")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  class: { hidden: _vm.saved },
                                                  attrs: {
                                                    color: "blue darken-1",
                                                    disabled: !_vm.valid,
                                                    type: "Submit"
                                                  }
                                                },
                                                [_vm._v("Save")]
                                              ),
                                              _vm._v(" "),
                                              _vm.formTitle === "New Jump"
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "blue darken-1",
                                                        disabled: !_vm.valid
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.saveAndClose()
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Save and Close")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    text: "",
                                                    disabled: !_vm.saved
                                                  },
                                                  on: { click: _vm.nextStep }
                                                },
                                                [_vm._v("Continue")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-form",
                                    {
                                      on: {
                                        submit: function($event) {
                                          $event.preventDefault()
                                          return _vm.addToBasket($event)
                                        }
                                      },
                                      model: {
                                        value: _vm.validItems,
                                        callback: function($$v) {
                                          _vm.validItems = $$v
                                        },
                                        expression: "validItems"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-stepper-step",
                                        {
                                          attrs: {
                                            complete: _vm.readyToPay,
                                            step: "2"
                                          },
                                          model: {
                                            value: _vm.forLater,
                                            callback: function($$v) {
                                              _vm.forLater = $$v
                                            },
                                            expression: "forLater"
                                          }
                                        },
                                        [_vm._v("Add to Basket")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-stepper-content",
                                        { attrs: { step: "2" } },
                                        [
                                          _c(
                                            "v-card-actions",
                                            [
                                              _vm._v(
                                                "\n                      Total: "
                                              ),
                                              _c("strong", [
                                                _vm._v(
                                                  "$ " + _vm._s(_vm.merch_total)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("v-spacer"),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "blue darken-1",
                                                    disabled: !_vm.validItems,
                                                    type: "Submit"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { left: "" } },
                                                    [_vm._v("mdi-basket-plus")]
                                                  ),
                                                  _vm._v(" Add")
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.editedItem.status == 1
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: { text: "" },
                                                      on: {
                                                        click: _vm.skipMerch
                                                      }
                                                    },
                                                    [_vm._v("Skip")]
                                                  )
                                                : _c(
                                                    "v-btn",
                                                    {
                                                      attrs: { text: "" },
                                                      on: { click: _vm.close }
                                                    },
                                                    [_vm._v("Cancel")]
                                                  )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-autocomplete", {
                                            staticClass: "basket",
                                            attrs: {
                                              items: _vm.filteredMerch,
                                              label:
                                                "Search for Merch, Addons, Tips for TI or the Team, or Split Pack Payment",
                                              "item-text": "name",
                                              "item-value": "id",
                                              multiple: "",
                                              rules: _vm.req,
                                              "hide-no-data": "",
                                              "prepend-icon": "mdi-magnify",
                                              "return-object": ""
                                            },
                                            on: { change: _vm.setItemValue },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "selection",
                                                fn: function(data) {
                                                  return [
                                                    data.item.category ===
                                                    "addons"
                                                      ? [
                                                          _c(
                                                            "v-chip",
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  "input-value":
                                                                    data.selected,
                                                                  close: "",
                                                                  outlined: "",
                                                                  label: ""
                                                                },
                                                                on: {
                                                                  click:
                                                                    data.select,
                                                                  "click:close": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeBillItem(
                                                                      data.item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              "v-chip",
                                                              data.attrs,
                                                              false
                                                            ),
                                                            [
                                                              _vm._v(
                                                                "\n\n                            " +
                                                                  _vm._s(
                                                                    data.item
                                                                      .name
                                                                  ) +
                                                                  " $" +
                                                                  _vm._s(
                                                                    data.item
                                                                      .price
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      : [
                                                          _c(
                                                            "v-chip",
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  "input-value":
                                                                    data.selected,
                                                                  close: "",
                                                                  outlined: "",
                                                                  label: ""
                                                                },
                                                                on: {
                                                                  click:
                                                                    data.select,
                                                                  "click:close": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeBillItem(
                                                                      data.item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              "v-chip",
                                                              data.attrs,
                                                              false
                                                            ),
                                                            [
                                                              _vm._v(
                                                                "\n\n                            " +
                                                                  _vm._s(
                                                                    data.item
                                                                      .name
                                                                  ) +
                                                                  " | " +
                                                                  _vm._s(
                                                                    data.item
                                                                      .m_l
                                                                  ) +
                                                                  " | " +
                                                                  _vm._s(
                                                                    data.item
                                                                      .colour
                                                                  ) +
                                                                  " | " +
                                                                  _vm._s(
                                                                    data.item
                                                                      .size
                                                                  ) +
                                                                  " $\n                            " +
                                                                  _vm._s(
                                                                    data.item
                                                                      .price
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                  ]
                                                }
                                              },
                                              {
                                                key: "item",
                                                fn: function(data) {
                                                  return [
                                                    data.item.category !==
                                                    "merch"
                                                      ? [
                                                          _c(
                                                            "v-list-item-content",
                                                            {
                                                              domProps: {
                                                                textContent: _vm._s(
                                                                  data.item
                                                                    .name +
                                                                    " $" +
                                                                    data.item
                                                                      .price
                                                                )
                                                              }
                                                            }
                                                          )
                                                        ]
                                                      : data.item.category ===
                                                        "merch"
                                                      ? [
                                                          _c(
                                                            "v-list-item-content",
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    data.item
                                                                      .name
                                                                  ) +
                                                                  " | " +
                                                                  _vm._s(
                                                                    data.item
                                                                      .m_l
                                                                  ) +
                                                                  " | " +
                                                                  _vm._s(
                                                                    data.item
                                                                      .colour
                                                                  ) +
                                                                  " | " +
                                                                  _vm._s(
                                                                    data.item
                                                                      .size
                                                                  ) +
                                                                  " $\n                            " +
                                                                  _vm._s(
                                                                    data.item
                                                                      .price
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.basket.billItems,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.basket,
                                                  "billItems",
                                                  $$v
                                                )
                                              },
                                              expression: "basket.billItems"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("small", [
                                            _vm._v("Total Items "),
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(_vm.filteredMerch.length)
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.customItemsValues,
                                            function(item) {
                                              return _c(
                                                "v-list",
                                                { key: item.id },
                                                [
                                                  _c("v-list-item", {
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function() {
                                                            return [
                                                              item.category ===
                                                              "tips"
                                                                ? [
                                                                    _c(
                                                                      "v-list-item-content",
                                                                      [
                                                                        item.name ==
                                                                        "Individual Tip"
                                                                          ? _c(
                                                                              "v-select",
                                                                              {
                                                                                attrs: {
                                                                                  "item-text":
                                                                                    "name",
                                                                                  "item-value":
                                                                                    "name",
                                                                                  items:
                                                                                    _vm.instructors,
                                                                                  rules:
                                                                                    _vm.req,
                                                                                  label:
                                                                                    "Instructor's name"
                                                                                },
                                                                                model: {
                                                                                  value:
                                                                                    item.notes,
                                                                                  callback: function(
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      item,
                                                                                      "notes",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                  expression:
                                                                                    "item.notes"
                                                                                }
                                                                              }
                                                                            )
                                                                          : _c(
                                                                              "label",
                                                                              [
                                                                                _vm._v(
                                                                                  "Team Tip"
                                                                                )
                                                                              ]
                                                                            )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-list-item-action",
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs: {
                                                                              type:
                                                                                "number",
                                                                              rules:
                                                                                _vm.priceReq,
                                                                              label:
                                                                                "Amount",
                                                                              prefix:
                                                                                "$"
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                item.price,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  item,
                                                                                  "price",
                                                                                  _vm._n(
                                                                                    $$v
                                                                                  )
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "item.price"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                : [
                                                                    _c(
                                                                      "v-list-item-content",
                                                                      [
                                                                        _vm._v(
                                                                          "\n                              Enter an amount betwen 20 and " +
                                                                            _vm._s(
                                                                              _vm
                                                                                .editedItem
                                                                                .price -
                                                                                20
                                                                            ) +
                                                                            "\n\n                            "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-list-item-action",
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs: {
                                                                              type:
                                                                                "number",
                                                                              rules: [
                                                                                _vm.min_max
                                                                              ],
                                                                              label:
                                                                                "Amount",
                                                                              prefix:
                                                                                "$"
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                item.price,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  item,
                                                                                  "price",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "item.price"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _c("FilterMerch")
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "4" } },
                                [
                                  _c(
                                    "v-form",
                                    {
                                      on: {
                                        submit: function($event) {
                                          $event.preventDefault()
                                          return _vm.pay($event)
                                        }
                                      },
                                      model: {
                                        value: _vm.validPayment,
                                        callback: function($$v) {
                                          _vm.validPayment = $$v
                                        },
                                        expression: "validPayment"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-stepper-step",
                                        { attrs: { step: "3" } },
                                        [_vm._v("Payment")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "payment" },
                                        [
                                          _c(
                                            "v-stepper-content",
                                            { attrs: { step: "3" } },
                                            [
                                              _vm.editedItem.code
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c("v-checkbox", {
                                                        class: {
                                                          hidden:
                                                            _vm.editedItem
                                                              .status == 2
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            (_vm.splitPayBalance !==
                                                              null &&
                                                              _vm.splitPayBalance !==
                                                                undefined) ||
                                                            (_vm.editedItem
                                                              .creditedItems &&
                                                              _vm.editedItem
                                                                .creditedItems
                                                                .length > 0) ||
                                                            _vm.isPrepaidAgent,
                                                          label:
                                                            "Prepaid Booking"
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.deductPckg()
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .prepaidBooking,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "prepaidBooking",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.prepaidBooking"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-text-field", {
                                                        ref: "price",
                                                        class: {
                                                          hidden:
                                                            _vm.editedItem
                                                              .status == 2
                                                        },
                                                        attrs: {
                                                          prefix: "$",
                                                          readonly: "",
                                                          type: "number",
                                                          label:
                                                            _vm.editedItem
                                                              .productName ||
                                                            "Package Price"
                                                        },
                                                        model: {
                                                          value: _vm.price,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.price = $$v
                                                          },
                                                          expression: "price"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-text-field", {
                                                        staticClass: "discount",
                                                        class: {
                                                          hidden:
                                                            _vm.editedItem
                                                              .status == 2
                                                        },
                                                        attrs: {
                                                          prefix: "$",
                                                          disabled:
                                                            _vm.editedItem
                                                              .prepaidBooking,
                                                          type: "number",
                                                          label:
                                                            "Package Discount"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .discount,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "discount",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.discount"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _vm.editedItem.status == 1
                                                        ? _c("v-text-field", {
                                                            class: {
                                                              hidden:
                                                                _vm.overweight ==
                                                                0
                                                            },
                                                            attrs: {
                                                              prefix: "$",
                                                              type: "number",
                                                              readonly: "",
                                                              label:
                                                                _vm
                                                                  .owSurcharge[0]
                                                                  .name
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.overweight,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.overweight = _vm._n(
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "overweight"
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("Bill", {
                                                attrs: {
                                                  items:
                                                    _vm.editedItem
                                                      .creditedItems,
                                                  status: _vm.editedItem.status,
                                                  customer_id:
                                                    _vm.editedItem.customer_id
                                                },
                                                on: {
                                                  removefromBasket:
                                                    _vm.removeBillItem
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("Purchased", {
                                                attrs: {
                                                  items: _vm.allItems,
                                                  status: _vm.editedItem.status,
                                                  customer_id:
                                                    _vm.editedItem.customer_id
                                                },
                                                on: {
                                                  removefromBasket:
                                                    _vm.removeBillItem
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  type: "number",
                                                  readonly: "",
                                                  prefix: "$",
                                                  label: "Merch & Addons"
                                                },
                                                model: {
                                                  value: _vm.merch_total,
                                                  callback: function($$v) {
                                                    _vm.merch_total = $$v
                                                  },
                                                  expression: "merch_total"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  class: {
                                                    hidden:
                                                      _vm.editedItem.status == 2
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Balance:\n                        "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      "$ " + _vm._s(_vm.total)
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-radio-group",
                                                {
                                                  attrs: {
                                                    disabled:
                                                      _vm.splitPayBalance !==
                                                        null &&
                                                      _vm.splitPayBalance !==
                                                        undefined,
                                                    rules: _vm.req,
                                                    flex: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editedItem
                                                        .paymentMethod,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.editedItem,
                                                        "paymentMethod",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editedItem.paymentMethod"
                                                  }
                                                },
                                                [
                                                  _c("v-radio", {
                                                    attrs: {
                                                      label: "CC",
                                                      value: "CC"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-radio", {
                                                    attrs: {
                                                      label: "Cash",
                                                      value: "Cash"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: { label: "Notes" },
                                                model: {
                                                  value: _vm.editedItem.notes,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "notes",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "editedItem.notes"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _vm.editedItem.code
                                                ? _c(
                                                    "v-card-actions",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            loading:
                                                              _vm.loading,
                                                            color: "green",
                                                            type: "Submit",
                                                            disabled:
                                                              !_vm.validPayment ||
                                                              _vm.step < 3
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                left: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-account-check"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v("Paid ")
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.editedItem.status == 1
                                                        ? _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                text: "",
                                                                disabled:
                                                                  _vm.step < 3
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.groupPay()
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    left: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-basket-plus"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " Group Payment"
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "v-card-actions",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            color: "green"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.walkInPay()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                left: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-cash-check"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" Paid")
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.jumps,
                      "items-per-page": 30,
                      "disable-pagination": "",
                      "item-key": "id",
                      loading: _vm.loading,
                      "show-expand": "",
                      expanded: _vm.expanded
                    },
                    on: {
                      "update:expanded": function($event) {
                        _vm.expanded = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.group",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            item.group == 1
                              ? _c("v-checkbox", {
                                  attrs: { value: item.id },
                                  model: {
                                    value: _vm.groupPaymentIDs,
                                    callback: function($$v) {
                                      _vm.groupPaymentIDs = $$v
                                    },
                                    expression: "groupPaymentIDs"
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "item.actions",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c(
                              "v-btn",
                              {
                                staticClass: "mx-2",
                                attrs: { icon: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.checkIn(item)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("mdi-account-check")])],
                              1
                            )
                          ]
                        }
                      },
                      {
                        key: "expanded-item",
                        fn: function(ref) {
                          var headers = ref.headers
                          var item = ref.item
                          return [
                            item.notes || item.merch.length > 0
                              ? _c(
                                  "td",
                                  { attrs: { colspan: headers.length } },
                                  [
                                    _c("Bill", {
                                      attrs: {
                                        items: item.merch,
                                        status: item.status,
                                        customer_id: item.customer_id
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v("Notes: " + _vm._s(item.notes))
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "6" } },
            [
              _c("WithAddons", {
                on: {
                  "edit-checkedIn": _vm.checkIn,
                  addMerchStep: _vm.addMerch
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("RecentlyAddedJumps")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }